/*eslint no-script-url: 0 */
import React, { Component } from "react";
import Parser from 'html-react-parser';

class QuickMenu extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
			quickMenu: [
				{
					"ID": 187,
					"url": "https://www.justpictureframingonline.com.au/",
					"title": "Home",
				},
				{
					"ID": 426,
					"url": "https://www.justpictureframingonline.com.au/picture-framing/",
					"title": "Products",
				},
				{
					"ID": 185,
					"url": "https://www.justpictureframingonline.com.au/interior-designer-tips/",
					"title": "Interior Designer Tips",
				},
				{
					"ID": 184,
					"url": "https://www.justpictureframingonline.com.au/postage-handling/",
					"title": "Postage & Handling",
				},
				{
					"ID": 182,
					"url": "https://www.justpictureframingonline.com.au/about-us/",
					"title": "About Us",
				},
				{
					"ID": 181,
					"url": "https://www.justpictureframingonline.com.au/faq/",
					"title": "FAQ",
				},
				{
					"ID": 180,
					"url": "https://www.justpictureframingonline.com.au/contact/",
					"title": "Contact",
				}
			]
	    }
  	}

  	render() {
  		const { quickMenu } = this.state;
	    return (
			<div className="footer-col">
				<h4>Quick Links</h4>
				<ul>
					{quickMenu.map( (menu) =>
				        <li key={menu.ID}><a href={menu.url}>{Parser(menu.title)}</a></li>
				    )}
				</ul>
			</div>
	    );
  	}
}

export default QuickMenu;